/**
 * Test IDs for QA automation.
 */
export const testIds = {
  relationshipItemEdit: "relationship-item-edit",
  relationshipItemDelete: "relationship-item-delete",
} as const;
